export const GET_EVENTS_FETCH = "GET_EVENTS_FETCH";
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
